<template>
  <v-card class="mb-6">
    <v-card-text class="py-0">
      <v-list class="my-0">
        <v-list-item :href="`/tutorials/${file}`">
          <v-list-item-icon>
            <v-icon>mdi-folder-zip</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{title}}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>fa fa-download</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DownloadBox',
  props: [
      'file',
      'title'
  ]
}
</script>

<style scoped>

</style>